/***********************************************************************
 *                           文件工具类                                 *
 * ********************************************************************/
// 文件转base64
export function fileToBase64(file, res, err) {
  var reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => {
    res(reader.result)
  }
  reader.onerror = function(error) {
    err(error)
  }
}
// 根据url获取blob值
export function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], {
    type: mime
  })
}
// 下载文件
export function downloadFile(url, name = "What's the fuvk") {
  var a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('download', name)
  a.setAttribute('target', '_blank')
  let clickEvent = document.createEvent('MouseEvents')
  clickEvent.initEvent('click', true, true)
  a.dispatchEvent(clickEvent)
}
// 下载base64文件
export function downloadFileByBase64(base64, name) {
  var myBlob = dataURLtoBlob(base64)
  var myUrl = URL.createObjectURL(myBlob)
  downloadFile(myUrl, name)
}



// WEBPACK FOOTER //
// ./src/utils/file.js